import { render, staticRenderFns } from "./ModalLinkRoblox.vue?vue&type=template&id=852e670e&scoped=true"
import script from "./ModalLinkRoblox.vue?vue&type=script&lang=js"
export * from "./ModalLinkRoblox.vue?vue&type=script&lang=js"
import style0 from "./ModalLinkRoblox.vue?vue&type=style&index=0&id=852e670e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852e670e",
  null
  
)

export default component.exports